import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const SagittariusShape = ({
  width = 40,
  height = 40,
  fillColor = '#FFF',
  style
}: BaseSVGType) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <g id="Layer_2" data-name="Layer 2">
      <g id="Horoscope" fill={fillColor}>
        <path d="M41,5H21a2,2,0,0,0,0,4H36.2L18,27.2l-5.6-5.6a2,2,0,0,0-2.8,2.8L15.2,30,5.6,39.6a1.9,1.9,0,0,0,0,2.8,1.9,1.9,0,0,0,2.8,0L18,32.8l5.6,5.6a1.9,1.9,0,0,0,2.8,0,1.9,1.9,0,0,0,0-2.8L20.8,30,39,11.8V27a2,2,0,0,0,4,0V7A2,2,0,0,0,41,5Z" />
      </g>
    </g>
  </svg>
);

export default SagittariusShape;
